/**
 * The client's mirror of the LOCAL player's COSMETIC layer — the garment override per slot (itemId or
 * "") plus the show-cosmetics toggle. Fed from the synced `Player.cos*` / `showCosmetics` fields; the
 * paperdoll + the billboard's display-appearance compose subscribe to it. The server is authoritative.
 */
export interface CosmeticState {
  hat: string;
  top: string;
  bottom: string;
  shoes: string;
  showCosmetics: boolean;
}

type Listener = (c: CosmeticState) => void;

class CosmeticStore {
  private state: CosmeticState = { hat: "", top: "", bottom: "", shoes: "", showCosmetics: true };
  private readonly listeners = new Set<Listener>();

  get(): CosmeticState { return this.state; }

  set(c: CosmeticState): void {
    this.state = c;
    for (const fn of this.listeners) fn(this.state);
  }

  /** Subscribe; immediately invoked with the current value. Returns unsubscribe. */
  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }
}

export const cosmeticStore = new CosmeticStore();
